import React from 'react';
import styled from 'styled-components';

interface DescriptionCellProps {
  description: string;
}

export function DescriptionCell({ description }: DescriptionCellProps) {
  return <CellWrapper>{description}</CellWrapper>;
}

const CellWrapper = styled.div`
  max-width: 350px;
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
